import React from "react";
import { Link } from 'react-router-dom'

import "./footer.css";

const Footer = ({ links }) => {
  return (
    <footer>
        {links.map((link, key) => (
          <Link key={key} to={link.href} target={link.target}>
            {link.title}
          </Link>
        ))}
    </footer>
  );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/index.jsx